export default __webpack_public_path__ + "static/media/BB_45.97f1bea3.png";